module.exports = __webpack_public_path__ + "img/horizontal_7_7_5.6ba75b5c.png";